@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  @if (!isLoading) {
    <div #tableWrapper class="topic-scoring__table-wrapper">
      @if (dataSourceNotFound) {
        <div class="text-center">
          <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
        </div>
      }
      @if (noData) {
        <div class="text-center">
          <h1>
            {{ t('widgets.no-data-found') }}
          </h1>
        </div>
      }
      @if (hasInvalidComparison) {
        <div class="text-center">
          <h1>
            {{ t('widgets.has-invalid-comparison') }}
          </h1>
        </div>
      }
      @if (noPermission) {
        <div class="text-center">
          <h1>{{ t('widgets.no-permission-to-view') }}</h1>
        </div>
      }
      @if (!dataSourceNotFound && !noData && !hasInvalidComparison && !noPermission) {
        @if (!widget.payload.isDrilledDown) {
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortDisableClear
            [matSortActive]="sort.active"
            [matSortDirection]="sort.direction"
            (matSortChange)="sort = $event"
          >
            <ng-container [matColumnDef]="key">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ t('widgets.datatable.topic') }}
              </th>
              <td mat-cell *matCellDef="let element" (click)="openCellMenu($event, element, key)">
                {{ getItemName(element) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="f1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ t('widgets.datatable.f1') }}
              </th>
              <td mat-cell *matCellDef="let element" [ngClass]="getCellClass('f1', element.f1)">
                {{ element.f1 | number: '1.2-2' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="toFind">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [matTooltip]="t('widgets.datatable.topic-total-tooltip')"
              >
                {{ t('widgets.datatable.topic-total') }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openCellMenu($event, element, 'toFind')"
              >
                {{ element.toFind | humanizeInt: 1 : 1000 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="found">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [matTooltip]="t('widgets.datatable.topic-hits-tooltip')"
              >
                {{ t('widgets.datatable.topic-hits') }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openCellMenu($event, element, 'found')"
              >
                {{ element.found | humanizeInt: 1 : 1000 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="foundCorrectly">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [matTooltip]="t('widgets.datatable.correct-tooltip')"
              >
                {{ t('widgets.datatable.correct') }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openCellMenu($event, element, 'foundCorrectly')"
              >
                {{ element.foundCorrectly | humanizeInt: 1 : 1000 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incorrect">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [matTooltip]="t('widgets.datatable.incorrect-tooltip')"
              >
                {{ t('widgets.datatable.incorrect') }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openCellMenu($event, element, 'incorrect')"
              >
                {{ element.incorrect | humanizeInt: 1 : 1000 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="missing">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [matTooltip]="t('widgets.datatable.missing-tooltip')"
              >
                {{ t('widgets.datatable.missing') }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="openCellMenu($event, element, 'missing')"
              >
                {{ element.missing | humanizeInt: 1 : 1000 }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
          </table>
        }
        @if (widget.payload.isDrilledDown) {
          <app-widget-chart
            #mentionsChart
            [dashboard]="dashboard"
            [widget]="widget"
            (needRedraw)="redrawWidget($event)"
            (loadingStarted)="loadingStarted.emit($event)"
            (loadingFinished)="loadingFinished.emit($event)"
            (goBackClicked)="unsetMentionsDocumentFilter(widget.payload.filters)"
          ></app-widget-chart>
        }
      }
      <div
        [matMenuTriggerFor]="menuTrigger"
        #menuTriggerElement="matMenuTrigger"
        class="context-menu-trigger"
      ></div>
    </div>
  }

  <mat-menu #menuTrigger="matMenu" class="menu-with-xi-icons">
    <ng-template matMenuContent let-item="item" let-row="row" let-column="column">
      <div mat-menu-item disabled>{{ item | truncate: 25 : '…' }}</div>

      @if (column === key && !dashboard.locked) {
        <button mat-menu-item (click)="hideItem(row)" [disabled]="!enableHideItems()">
          <xi-icon
            [color]="!enableHideItems() ? 'disabled' : 'orca'"
            icon="remove_circle"
          ></xi-icon>
          <div>{{ hideItemLabel }}</div>
        </button>
      }
      @if (column !== key) {
        <button
          mat-menu-item
          [disabled]="row[column] === 0"
          (click)="showDocuments(item, row, column)"
        >
          <xi-icon [color]="row[column] === 0 ? 'disabled' : 'orca'" icon="preview"></xi-icon>
          <div>{{ t('widgets.show-documents') }}</div>
        </button>
      }

      <div [matTooltip]="showMentionsToolTip(row[column])">
        @if (column === 'incorrect') {
          <button mat-menu-item (click)="showMentions(item)" [disabled]="!hasMentions(row[column])">
            <xi-icon
              [color]="!hasMentions(row[column]) ? 'disabled' : 'orca'"
              icon="visibility"
            ></xi-icon>
            <div>{{ t('widgets.show-mentions') }}</div>
          </button>
        }
      </div>
    </ng-template>
  </mat-menu>

  @if (showDocumentViewModal) {
    <app-lex-xi-modal
      [isVisible]="showDocumentViewModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onDocumentViewModalClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showDocumentViewModal) {
          <app-document-view-dialog
            [options]="documentViewModalOptions"
            (modalClosed)="onDocumentViewModalClosed($event)"
          ></app-document-view-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
